import { render, staticRenderFns } from "./ShowManage.vue?vue&type=template&id=8c171a60&scoped=true&lang=pug&"
import script from "./ShowManage.vue?vue&type=script&lang=js&"
export * from "./ShowManage.vue?vue&type=script&lang=js&"
import style0 from "./ShowManage.vue?vue&type=style&index=0&id=8c171a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c171a60",
  null
  
)

export default component.exports